import store from '../store'
import {addFollowerToDoc} from '../actions/docs'


export function followDoc(docId) {
	store.dispatch(addFollowerToDoc(docId)).then((response)=>{

	})
}
